import { HttpClient } from '@angular/common/http';
import { GraphQL } from 'app/graphql';
import { BehaviorSubject, Observable } from 'rxjs';

export class LangModels {
  private langModelsFirstCall = true;
  private langModels = new BehaviorSubject<GraphQL.ASR.LangModel[]>([]);

  constructor(
    protected http: HttpClient
  ) { }

  initLangModels() {
    this.langModels = new BehaviorSubject<GraphQL.ASR.LangModel[]>([]);
    this.refreshLangModels();
  }

  getLangModels(): Observable<GraphQL.ASR.LangModel[]>;
  getLangModels(asSnapshot: boolean): GraphQL.ASR.LangModel[];
  getLangModels(asSnapshot?: boolean) {
    if (this.langModelsFirstCall) {
      this.refreshLangModels();
      this.langModelsFirstCall = false;
    }
    if (asSnapshot) {
      return this.langModels.getValue();
    }
    return this.langModels.asObservable();
  }

  private refreshLangModels() {
    let lang = new GraphQL.ASR.LangModel;
    lang.id = 0;
    lang.lang = 'POL';
    lang.comment = '#whisper';
    lang.createdAt = '2024';
    this.langModels.next([lang]);
    return;
  }
}
